import { brandNeutralColors, colors } from './theme';

export const sampleThemes = {
  'Compass (AnyRoad)': { colors },
  Budweiser: {
    colors: { ...colors, ...brandNeutralColors, primary: '#e01a25' },
  },
  'Dicks House of Sport': {
    colors: { ...colors, ...brandNeutralColors, primary: '#00655c' },
  },
  'The Stitzel-Weller Experience': {
    colors: { ...colors, ...brandNeutralColors, primary: '#274635' },
  },
};
